export default (hit, isInit) => {
  return `
  <button ${isInit ? 'js-scroll-animations-target style="opacity: 0"' : ''} class="display-mobile contribution-card" js-modal-control="{target: '#modal-contribution', dynamic: true, type: 'contribution'}" data-id="${hit.internalId}">
    <div class="contribution-card__inner">
        <div class="contribution-card__logo-wrap">
          <img src="https://res.cloudinary.com/dbozkenbr/image/upload/c_limit,f_auto,q_auto,w_155,h_90/${hit.logo.singleMedia.publicId}" alt="${hit.title}" class="contribution-card__logo" />
        </div>
        
        <div>
            <p class="text-20 md:text-24 mb-1">${hit.title}</p>
            <p class="text-14">${hit.activity}</p>

            ${hit.tags.length > 0
              ? hit.tags.map((tag, i) => {
                return (
                  `<p class="contribution-card__tag">
                    <svg width="12" height="12">
                        <use href="#icon-star" xlink:href="#icon-star" />
                    </svg>
                    ${tag}
                  </p>
                  `
                )
              }).join('')
              : ''
            }
        </div>
    </div>
  </button>
  `
}
